import authRoutes from './modules/auth.routes'
import dashboardRoutes from './modules/dashboard.routes'
import bannersRoutes from './modules/banners.routes'
import promotionsRoutes from './modules/promotions.routes'
import newsRoutes from './modules/news.routes'
import reservationsRoutes from './modules/reservations.routes'
import configRoutes from './modules/config.routes'
import schedulesRoutes from './modules/schedules.routes'
import contactRoutes from './modules/contact.routes'
import emailsRoutes from './modules/emails.routes'
import privacyNoticeRoutes from './modules/privacy-notice.routes'
import servicesRoutes from './modules/services.routes'

const routes = [
  authRoutes,
  {
    path: '/console',
    name: 'console',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      dashboardRoutes,
      bannersRoutes,
      promotionsRoutes,
      newsRoutes,
      reservationsRoutes,
      configRoutes,
      schedulesRoutes,
      contactRoutes,
      emailsRoutes,
      privacyNoticeRoutes,
      servicesRoutes,
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
